import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [needsVerify, setNeedsVerify] = useState(false);
  const [resending, setResending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "";
      if (typeof msg === "string" && msg.startsWith("EMAIL_NOT_VERIFIED")) {
        setNeedsVerify(true);
        toast.error("Please confirm your email before signing in");
      } else {
        toast.error(apiError(err, "Sign-in failed"));
      }
    } finally {
      setLoading(false);
    }
  };

  const resend = async () => {
    setResending(true);
    try {
      await api.post("/auth/resend-verification", { email });
      toast.success("Verification email re-sent");
    } catch (e) {
      toast.error(apiError(e, "Could not resend"));
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="font-mono-cal text-[11px] uppercase tracking-[0.2em] text-[#666] mb-4">[02] Authenticate</div>
      <h1 className="font-display font-bold text-5xl mb-8">Sign in</h1>
      <form onSubmit={submit} className="cal-card p-8 space-y-5" data-testid="login-form">
        <div>
          <label className="cal-label">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="cal-input" data-testid="login-email" />
        </div>
        <div>
          <label className="cal-label">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="cal-input" data-testid="login-password" />
        </div>
        <button type="submit" disabled={loading} className="cal-btn w-full" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign in →"}
        </button>
        {needsVerify && (
          <div className="border-l-4 border-l-[#FF4F00] bg-[#FFF6F0] p-4 text-sm" data-testid="login-needs-verify">
            <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#FF4F00] mb-1">[ EMAIL NOT CONFIRMED ]</div>
            <p className="text-[#666] mb-3">Click the link we sent you, or get a fresh one:</p>
            <button type="button" onClick={resend} disabled={resending} className="cal-btn cal-btn-ghost w-full" data-testid="login-resend-verify-btn">
              {resending ? "Sending…" : "Resend verification email"}
            </button>
          </div>
        )}
      </form>
      <p className="mt-6 text-sm text-[#666]">
        <Link to="/forgot-password" className="underline hover:text-[#FF4F00]" data-testid="link-forgot">Forgot password?</Link>
        <span className="mx-2">·</span>
        No account? <Link to="/register" className="underline hover:text-[#FF4F00]" data-testid="link-register">Register here</Link>
      </p>
    </div>
  );
}
